/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_DescriptionInputs */

const en_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the Machine Id from your offline system and click Activate to generate an Activation Code`)
};

const fr_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez l'identifiant machine de votre systeme hors ligne et cliquez sur Activer pour generer un code d'activation`)
};

const de_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie die Maschinen-ID Ihres Offline-Systems ein und klicken Sie auf „Aktivieren“, um einen Aktivierungscode zu generieren.`)
};

const it_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci l'ID macchina dal tuo sistema offline e fai clic su Attiva per generare un codice di attivazione`)
};

const ru_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите идентификатор устройства из вашей автономной системы и нажмите «Активировать», чтобы сгенерировать код активации.`)
};

const es_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese el ID de la máquina de su sistema fuera de línea y haga clic en Activar para generar un código de activación`)
};

const zh_cn2_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入离线系统中的机器 ID，然后单击“激活”以生成激活码。`)
};

const ja_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインシステムからマシンIDを入力し、「アクティベート」をクリックしてアクティベーションコードを生成します。`)
};

const hi_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने ऑफ़लाइन सिस्टम से मशीन आईडी दर्ज करें और एक्टिवेशन कोड जनरेट करने के लिए एक्टिवेट पर क्लिक करें।`)
};

const pt_pt2_offline_activation_description = /** @type {(inputs: Offline_Activation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o ID da máquina do seu sistema offline e clique em Ativar para gerar um código de ativação.`)
};

/**
* | output |
* | --- |
* | "Enter the Machine Id from your offline system and click Activate to generate an Activation Code" |
*
* @param {Offline_Activation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_description = /** @type {((inputs?: Offline_Activation_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_description(inputs)
	if (locale === "de") return de_offline_activation_description(inputs)
	if (locale === "it") return it_offline_activation_description(inputs)
	if (locale === "ru") return ru_offline_activation_description(inputs)
	if (locale === "es") return es_offline_activation_description(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_description(inputs)
	if (locale === "ja") return ja_offline_activation_description(inputs)
	if (locale === "hi") return hi_offline_activation_description(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_description(inputs)
	return en_offline_activation_description(inputs)
});